export default __webpack_public_path__ + "static/media/businessman.2b486dd5.svg";